import { ZIndexOptions } from '@mildang/mui';

export type CustomZIndex = {
  screenActionArea: number;
  loading: number;
  toolbar: number;
  stickyBlock: number;
};

export const zIndex: Required<ZIndexOptions> & CustomZIndex = {
  screenActionArea: 10,
  loading: 11,
  toolbar: 12,
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  stickyBlock: 1111,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
  syncBorder: 10000,
};
